import { Plugin, PluginKey } from "prosemirror-state";
import { EditorView } from "prosemirror-view";

export function linkClickPlugin() {
	let lastTap = 0;
	let lastTarget: HTMLElement | null = null;

	return new Plugin({
		key: new PluginKey("linkClick"),

		props: {
			handleDOMEvents: {

				mousedown(view: EditorView, event: MouseEvent) {
					// Check if the target is a link
					const target = event.target as HTMLElement;
					if (target.tagName === "A") {
						// If Meta key is pressed, open the link in a new tab
						if (event.metaKey || event.ctrlKey) {
							event.preventDefault();
							const href = target.getAttribute("href");
							if (href) {
								window.open(href, "_blank");
							}
							return true; // Prevents further handling
						}
					}
					return false; // Allow default behavior otherwise
				},

				/** Double-tap on touch devices */
				touchend(view: EditorView, event: TouchEvent) {
					const target = event.target as HTMLElement;
					if (target.tagName === "A") {
						const currentTime = Date.now();
						const tapInterval = currentTime - lastTap;

						if (lastTarget === target && tapInterval < 300) { // Double-tap detected
							event.preventDefault();
							const href = target.getAttribute("href");
							if (href) {
								window.open(href, "_blank");
							}
							lastTap = 0; // Reset tap time
							return true;
						}

						lastTarget = target;
						lastTap = currentTime;
					}
					return false; // Let ProseMirror handle single taps
				},

				// ********* CURSOR CHANGING SUPPORT ************

				mouseover(view: EditorView, event: MouseEvent) {
					const target = event.target as HTMLElement;
					// Check if the target is a link
					if (target.tagName === "A") {
						// Change cursor to pointer if Meta/Ctrl key is pressed
						if (event.metaKey || event.ctrlKey) {
							target.style.cursor = "pointer";
						}
					}
					return false; // Let ProseMirror handle other aspects
				},


				mouseout(view: EditorView, event: MouseEvent) {
					const target = event.target as HTMLElement;

					// Reset cursor style when leaving the link
					if (target.tagName === "A") {
						target.style.cursor = "";
					}
					return false;
				},


				mousemove(view: EditorView, event: MouseEvent) {
					const target = event.target as HTMLElement;

					// Update cursor dynamically based on Meta/Ctrl key
					if (target.tagName === "A") {
						if (event.metaKey || event.ctrlKey) {
							target.style.cursor = "pointer";
						} else {
							target.style.cursor = ""; // Reset cursor if key is not pressed
						}
					}
					return false;
				},
			},
		},
	});
}
